import React from 'react';

export const MeasurementLogo = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="36"
      height="36"
      viewBox="0 0 36 36"
      fill="none"
    >
      <path
        d="M2.5454 15.4544L15.4542 2.54558C16.8601 1.13969 19.1395 1.13969 20.5454 2.54558L33.4542 15.4544C34.8601 16.8603 34.8601 19.1397 33.4542 20.5456L20.5454 33.4544C19.1395 34.8603 16.8601 34.8603 15.4542 33.4544L2.54541 20.5456C1.13952 19.1397 1.13952 16.8603 2.5454 15.4544Z"
        fill="#1056FB"
      />
      <mask
        id="mask0_6350_22545"
        maskUnits="userSpaceOnUse"
        x="1"
        y="1"
        width="34"
        height="34"
      >
        <path
          d="M2.5448 15.4544L15.4536 2.54555C16.8595 1.13966 19.1389 1.13966 20.5448 2.54555L33.4536 15.4544C34.8595 16.8603 34.8595 19.1397 33.4536 20.5455L20.5448 33.4544C19.1389 34.8603 16.8595 34.8603 15.4536 33.4544L2.54481 20.5456C1.13892 19.1397 1.13892 16.8603 2.5448 15.4544Z"
          fill="white"
        />
      </mask>
      <g mask="url(#mask0_6350_22545)">
        <g filter="url(#filter0_i_6350_22545)">
          <circle
            cx="17.9993"
            cy="30.6"
            r="16.2"
            fill="url(#paint0_linear_6350_22545)"
          />
        </g>
      </g>
      <defs>
        <filter
          id="filter0_i_6350_22545"
          x="1.79934"
          y="14.4"
          width="32.4"
          height="32.85"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="BackgroundImageFix"
            result="shape"
          />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="0.45" />
          <feGaussianBlur stdDeviation="0.9" />
          <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.32 0"
          />
          <feBlend
            mode="plus-lighter"
            in2="shape"
            result="effect1_innerShadow_6350_22545"
          />
        </filter>
        <linearGradient
          id="paint0_linear_6350_22545"
          x1="17.9993"
          y1="46.8"
          x2="17.9993"
          y2="14.4"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#1056FB" />
          <stop offset="1" stopColor="#34D0F7" />
        </linearGradient>
      </defs>
    </svg>
  );
};
